import merge from 'lodash/merge'

// Swiper transaction statuses
const TRANSACTION_STATUSES = {
  APPROVED: 'APPROVED',
  APPROVED_PIN: 'APPROVED_PIN',
  APPROVED_SIGNATURE: 'APPROVED_SIGNATURE',
  CANCELLED: 'CANCELLED',
  CANCELLED_BAD_CARD: 'CANCELLED_BAD_CARD',
  CANCELLED_BUSY: 'CANCELLED_BUSY',
  PARTIAL_APPROVED: 'PARTIAL_APPROVED',
  COMPLETED: 'COMPLETED',
  DECLINED: 'DECLINED',
  PROCESSING: 'PROCESSING',
  REFUNDED: 'REFUNDED',
  REVERSED: 'REVERSED',
  TIMEOUT: 'TIMEOUT',
}

// Error workflows for the modal
const ERROR_WORKFLOWS = {
  CANCELLED: 'CANCELLED',
  CANCELLED_BUSY: 'CANCELLED BUSY',
  CANCELLED_BAD_CARD: 'CANCELLED BAD CARD',
  DECLINED: 'DECLINED',
  DECLINED_CASHIER: 'DECLINED CASHIER',
  NO_TERMINAL: 'NO TERMINAL',
  TIMEOUT: 'TERMINAL TIMEOUT',
  NO_PAIRING: 'NO PAIRING',
  INVALID_AMOUNT_INPUT: 'INVALID AMOUNT INPUT',
  INVALID_NEGATIVE_AMOUNT_INPUT: 'INVALID NEGATIVE AMOUNT INPUT',
  UNAVAILABLE_REVERSAL_STATUS: 'UNAVAILABLE REVERSAL STATUS',
  UNKNOWN: 'UNKNOWN',
  ECONDUIT_ERROR: 'ECONDUIT ERROR',
  OVER_REFUND: 'OVER REFUND',
}

// Workflows for the modal
const WORKFLOWS = merge(
  {},
  {
    APPROVE: 'APPROVE',
    PARTIAL_APPROVED: 'PARTIAL_APPROVED',
    FAILED_SIGNATURE: 'FAILED SIGNATURE',
    FAILED_SIGNATURE_APPROVE: 'FAILED SIGNATURE APPROVE',
    PROCESSING: 'PROCESSING',
    REVERSING: 'REVERSING',
  },
  ERROR_WORKFLOWS
)

// Error workflow content for the modal
const ERROR_CONTENT = {
  [WORKFLOWS.CANCELLED]: {
    header: 'This payment has been cancelled.',
    content: 'The transaction was cancelled, try again.',
  },
  [WORKFLOWS.CANCELLED_BAD_CARD]: {
    header: 'This payment has been declined.',
    content:
      'The card that was presented is unsupported by the processor and cannot be accepted, try a different card.',
  },
  [WORKFLOWS.CANCELLED_BUSY]: {
    header: 'This payment has been cancelled.',
    content:
      'The terminal was busy and rejected the transaction, wait a moment then try again.',
  },
  [WORKFLOWS.DECLINED_CASHIER]: {
    header: 'This payment has been cancelled.',
    content: `No payment has been taken because you’ve just declined this transaction. If you feel suspicious about a
      cardholder, please refer to your store policy or get in touch with your manager.`,
  },
  [WORKFLOWS.DECLINED]: {
    header: 'This payment has been declined.',
    content: 'The transaction was declined, try again or use a different card.',
  },
  [WORKFLOWS.NO_TERMINAL]: {
    header: 'This register is not set up to use this payment type.',
    content: `The register needs to be paired with a terminal to be able to use this payment type.
      Please choose another payment type to complete this sale.`,
  },
  [WORKFLOWS.TIMEOUT]: {
    header: 'This payment has been cancelled.',
    content:
      'No payment has been taken because this transaction took too long.',
  },
  [WORKFLOWS.INVALID_AMOUNT_INPUT]: {
    header: 'Something went wrong with this payment.',
    content:
      'Sorry, that didn’t work. Payments must have a value greater than $0.00.',
  },
  [WORKFLOWS.INVALID_NEGATIVE_AMOUNT_INPUT]: {
    header: 'Something went wrong with this payment.',
    content: `Sorry, that didn’t work. Payments must have a value greater than $0.00.
    Refunds can be performed by returning sales in Sales History.`,
  },
  [WORKFLOWS.UNAVAILABLE_REVERSAL_STATUS]: {
    header: 'Something went wrong with this payment.',
    content: `Sorry, that didn’t work. We were unable to reverse this transaction.
    You can try again, or process a return from Sales History.`,
  },
  [WORKFLOWS.ECONDUIT_ERROR]: {
    header: 'Something went wrong with this payment.',
    content: `You can try this payment type again, or choose another payment type to complete the sale.
      If this keeps happening, please contact your processor.`,
  },
  [WORKFLOWS.OVER_REFUND]: {
    header: 'Choose another payment type to refund this sale.',
    content: `The Credit Card payment type can only be used to refund sales which were fully paid using this payment type.`,
  },
  [WORKFLOWS.UNKNOWN]: {
    header: 'Something went wrong with this payment.',
    content:
      'Something went wrong. You can try again, or complete this sale with another payment type.',
  },
}

const API_ERRORS: Record<number, string> = {
  1302: ERROR_WORKFLOWS.NO_TERMINAL,
  1400: ERROR_WORKFLOWS.UNKNOWN,
  1401: ERROR_WORKFLOWS.UNKNOWN,
  1402: ERROR_WORKFLOWS.INVALID_AMOUNT_INPUT,
  1403: ERROR_WORKFLOWS.INVALID_NEGATIVE_AMOUNT_INPUT,
  130000: ERROR_WORKFLOWS.NO_TERMINAL,
  130008: ERROR_WORKFLOWS.NO_TERMINAL,
  130010: ERROR_WORKFLOWS.UNAVAILABLE_REVERSAL_STATUS,
  180002: ERROR_WORKFLOWS.OVER_REFUND,
  190000: ERROR_WORKFLOWS.ECONDUIT_ERROR,
}

export {
  API_ERRORS,
  ERROR_CONTENT,
  TRANSACTION_STATUSES,
  WORKFLOWS,
  ERROR_WORKFLOWS,
}
